import { render, staticRenderFns } from "./StudentChatCard.vue?vue&type=template&id=4e96c79c&scoped=true"
import script from "./StudentChatCard.vue?vue&type=script&lang=js"
export * from "./StudentChatCard.vue?vue&type=script&lang=js"
import style0 from "./StudentChatCard.vue?vue&type=style&index=0&id=4e96c79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96c79c",
  null
  
)

export default component.exports